import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import type { NewsletterWidgetProps } from "scmp-sdk";
import { NewsletterVariant } from "scmp-sdk";

import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";
import type { inlineWidgetContent$key } from "scmp-app/queries/__generated__/inlineWidgetContent.graphql";

import { Container, StyledContentNewsletterWidget } from "./styles";

export type ExtraProps = {
  newsletterVariant?: NewsletterWidgetProps["variant"];
};

type Props = ContentSchemaRenderProps &
  ExtraProps & {
    reference?: inlineWidgetContent$key;
  };

const Component: FunctionComponent<Props> = ({
  newsletterVariant = NewsletterVariant.Article,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment inlineWidgetContent on Content {
        ...contentNewsletterWidgetContent
      }
    `,
    reference ?? null,
  );
  if (!content) return null;

  return (
    <Container>
      <StyledContentNewsletterWidget reference={content} variant={newsletterVariant} />
    </Container>
  );
};

Component.displayName = "InlineWidget";
export const InlineWidget = styled(Component)``;
